module.exports = __webpack_public_path__ + "img/6-4.56a8cee6.png";